import React, {useContext, useEffect, useState} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
// import {Line} from 'react-chartjs-2';
import {makeStyles} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Divider,
    Button
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';

import {data, options} from './chart';
import AppContext from "../../AppContext";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(() => ({
    root: {},
    // chartContainer: {
    //     height: 400,
    //     position: 'relative'
    // },
    actions: {
        justifyContent: 'flex-end'
    },
    selectMenu: {
        display: 'none',
    },
    formControl: {
        display: 'none',
    },
}));

const EnsemblePanel = props => {
    const {className, ...rest} = props;
    const context = useContext(AppContext);
    const classes = useStyles();
    const formatData = (iterData) => {
        const data = [];
        iterData.map((iter, iterIdx) => {
            // TODO: Error bars doesn't work
            data.push({
                iteration: iter.iteration_id == 9 ? "refine" : iter.iteration_id,
                ensemble_backbone_rmsd_all: iter["ensemble_backbone_rmsd_all"],
                ensemble_heavy_rmsd_all: iter["ensemble_heavy_rmsd_all"],
                ensemble_backbone_rmsd_ordered: iter["ensemble_backbone_rmsd"],
                ensemble_heavy_rmsd_ordered: iter["ensemble_heavy_rmsd"],
            })
        });
        return data
    };
    const iterData = context.state.data.iterations ? formatData(context.state.data.iterations) : null;
    const [anchorSelect, setAnchorSelect] = useState(null);
    const plotFlags = ["All residues", "Ordered residues"];
    const [plotFlagIdx, setPlotFlagIdx] = useState(0);
    const ensSize = context.state.data ? context.state.data.iterations[context.state.iteration_id]["ensemble_size"] : ""
    const handleChange = (event) => {
    };
    // useEffect(() => {setFlagIdx()}, [anchorSelect])
    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent>
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom>
                    Ensemble RMSD
                </Typography>
                <ResponsiveContainer
                    width="100%"
                    height={600}>
                    <LineChart
                        data={iterData}
                        margin={{top: 5, right: 20, bottom: 10, left: 20}}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis
                            dataKey="iteration"
                            fontFamily="sans-serif"
                            label={{
                                value: "Iteration",
                                offset: -5,
                                position: "insideBottom"
                            }}
                        />
                        <YAxis
                            fontFamily="sans-serif"
                            label={{
                                value: "RMSD [\u212B]",
                                offset: 0,
                                angle: -90,
                                position: "insideLeft"
                            }}
                        />
                        <Tooltip filterNull={false} />
                        <Legend iconType="plainline"
			    wrapperStyle={{
				    paddingTop: "10px"
				}}
			/>
                        <Line type="monotone" connectNulls
                              dataKey="ensemble_backbone_rmsd_all"
			      name="Backbone (All)"
                              stroke="#8884d8"
			      strokeDasharray="5 5"
			/>
                        <Line type="monotone" connectNulls
                              dataKey="ensemble_heavy_rmsd_all"
			      name="Heavy atoms (All)"
                              stroke="#82ca9d"
			      strokeDasharray="5 5"
			/>
                        <Line type="monotone" connectNulls
                              dataKey="ensemble_backbone_rmsd_ordered"
			      name="Backbone (Ordered)"
                              stroke="#8884d8"
			      strokeWidth="1.5"
			/>
                        <Line type="monotone" connectNulls
                              dataKey="ensemble_heavy_rmsd_ordered"
			      name="Heavy atoms (Ordered)"
                              stroke="#82ca9d"
			      strokeWidth="1.5"
			/>
			/>
                    </LineChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
};

EnsemblePanel.propTypes = {
    className: PropTypes.string
};

export default EnsemblePanel;
